import './SearchInput.scss';
import { useId } from 'react';
import { SearchIcon } from '../../assets/react-icons/';
import _ from 'lodash';

const SearchInput = ({
  id,
  update
}) => {
  const debouncedSearch = _.debounce((input) => update({ 'keyword': input }), 1000);

  function handleChange(val) {
    debouncedSearch(val);
  };

  const generateId = useId();
  const inputId = id || generateId;

  return (
    <div className="search-input-container" >
      <input type="text" id={inputId} onChange={(e) => handleChange(e.target.value)} placeholder="Search by keyword" />
      <span>
        <SearchIcon color="rgba(0,0,0,.6)" width={24} />
      </span>
    </div>
  );
};

export default SearchInput;
